import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "toggle", "icon"]
  static values = { 
    expanded: { type: Boolean, default: false },
    previewLines: { type: Number, default: 3 }
  }

  connect() {
    console.log('[CollapsibleJson] Connected')
    this.updateDisplay()
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.updateDisplay()
  }

  updateDisplay() {
    if (this.expandedValue) {
      this.previewTarget.classList.add('hidden')
      this.fullTarget.classList.remove('hidden')
      this.toggleTarget.textContent = 'Collapse'
      if (this.hasIconTarget) {
        this.iconTarget.classList.add('rotate-180')
      }
    } else {
      this.previewTarget.classList.remove('hidden')
      this.fullTarget.classList.add('hidden')
      this.toggleTarget.textContent = 'Expand'
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove('rotate-180')
      }
    }
  }
}
